import { parse, format, resolve } from 'url';

const url = {
  parse: parse,
  format: format,
  resolve: resolve
};

export { url };
//# sourceMappingURL=url.mjs.map
